import React,{useState} from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import {Link,useNavigate} from 'react-router-dom'
import axios from 'axios'
import axiosClient from '../axios-client'

const defaultTheme = createTheme();

export default function SignIn() {
  const navigate = useNavigate()
  // localStorage.clear()
  console.log(process.env.REACT_APP_BASE_URL)
  const [issue,setIssue] = useState(null)
  const [message,setMessage] = useState(null)

  const DEF_DELAY = 1000;

  const textInputs = [
    {
      type:'text',
      name:'reg-number',
      required:true,
      placeholder:'enm211-0180/2020',
      autoFocus:true,
      id:0,
    },
    {
      type:'password',
      name:'password',
      required:true,
      placeholder:'****',
      autoFocus:true,
      id:1,
    },
  ]

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms || DEF_DELAY));
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const payload = {
      email: data.get('email'),
      password: data.get('password'),
    };
    const url = 'https://mykura-nodejs-backend-fca8901da273.herokuapp.com/api/login'
    const url2 = 'http://localhost:5000/api/login'
    axios.post(url,payload)
    .then((res) => {
      if (res.data.message) {
        console.log(res.data)
        setMessage(res.data.message)
        localStorage.setItem('token',res.data.accessToken)

        localStorage.setItem("userId",res.data.userId)
        
        setTimeout(() => {navigate('/app')},1000)
      }
      if (res.data.issue) setIssue(res.data.issue)
    })
    .catch((err) => console.log(err.message))
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      

<div className='h-screen flex flex-col items-center mt-[20%] sm:mt-0 sm:justify-center'>
        <CssBaseline />
        <div
        className='mt-8 flex flex-col items-center sm:mt-0'
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>

          <h3 
          style={{fontFamily: "Kaushan Script"}}
          className='font-semibold text-xl'>Sign In</h3>
          
          <h1 
          className='font-bold my-4 text-2xl'
          >Fill in the below details</h1>
          
          {message && (<Alert severity="success" onClose={() => setMessage(null)}><AlertTitle>{message}</AlertTitle></Alert>)}
          {issue && (<Alert severity="error" onClose={() => setIssue(null)}><AlertTitle>{issue}</AlertTitle></Alert>)}

          <form 
          className='mt-3 w-[350px]'
          onSubmit={handleSubmit}
          action="">

            <div className='grid gap-5'>
              

              {textInputs.map((d) => {
                const {type,name,placeholder,id} = d
                return (
                  <div 
                  className='grid gap-1 font-semibold'
                  key={id}>
                    <label 
                    className='capitalize'
                    htmlFor="">{name}</label>
                    <input
                    className='bg-transparent  px-2 py-2 rounded-sm border-none outline-none ring-2 ring-slate-400 text-slate-900 focus:ring-blue '
                    type={type}
                    name = {name}
                    placeholder={placeholder}
                    aria-required
                    required
                    autoFocus
                    />
                  </div>
                )
              })}
             
              <button 
              className='text-white bg-blue rounded-sm flex items-center justify-center font-semibold w-full py-2 disabled:bg-blue/25'
              
              type='submit'>
                Sign in
              </button>

              <Link
              to='/sign-in'
              className='text-blue font-semibold mt-2'
              >
                Already have an account? Sign in
              </Link>
            </div>


          </form>
        </div>
      </div>
    </ThemeProvider>
  );
}